import React from 'react';
import clsx from 'clsx';

interface StatProps {
  label: string;
  value: React.ReactNode;
  hint?: React.ReactNode;
  trend?: { direction: 'up' | 'down' | 'flat'; text: string };
  icon?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const Stat: React.FC<StatProps> = ({ label, value, hint, trend, icon, size = 'md', className }) => (
  <div className={clsx('ui-stat', `ui-stat--${size}`, className)}>
    <div className="ui-stat__head">
      <span className="ui-stat__label">{label}</span>
      {icon && <span className="ui-stat__icon">{icon}</span>}
    </div>
    <div className="ui-stat__value">{value}</div>
    {hint && <div className="ui-stat__hint">{hint}</div>}
    {trend && (
      <div className={clsx('ui-stat__trend', `ui-stat__trend--${trend.direction}`)}>
        <span aria-hidden>{trend.direction === 'up' ? '▲' : trend.direction === 'down' ? '▼' : '■'}</span> {trend.text}
      </div>
    )}
  </div>
);
